import { MotifToast } from "@ey-xd/motif-react";
import { useEffect, useState } from "react";
import "./SKUToast.scss";
interface SKUToastProps {
  variantType?: "success" | "error";
  message?: string;
  timer?: number;
}

export function SKUToast({
  variantType = "success",
  message = "updated successfully",
  timer = 5000,
}: SKUToastProps) {
  const [showToastSuccess, setShowToastSuccess] = useState(true);
  useEffect(() => {
    // setTimeout(() => {
    setShowToastSuccess(true);
    // }, timer);
  }, [timer]);
  if (!showToastSuccess) {
    return <></>;
  }
  return (
    <div className="product-preview-toast">
      <MotifToast variant={variantType}>
        <div slot="toast-supporting-text">{message}</div>
      </MotifToast>
    </div>
  );
}
